/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistBand
 */
export interface ArtistBand {
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    stageName: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBand
     */
    manualStageName: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    readonly type?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    readonly sourceIds?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    readonly isPermanentMember?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    readonly isMainPerformer?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistBand
     */
    readonly linkedAliasId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBand
     */
    createdBySystem?: boolean;
}

/**
 * Check if a given object implements the ArtistBand interface.
 */
export function instanceOfArtistBand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageName" in value;
    isInstance = isInstance && "manualStageName" in value;

    return isInstance;
}

export function ArtistBandFromJSON(json: any): ArtistBand {
    return ArtistBandFromJSONTyped(json, false);
}

export function ArtistBandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistBand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageName': json['stageName'],
        'manualStageName': json['manualStageName'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'sourceIds': !exists(json, 'source_ids') ? undefined : json['source_ids'],
        'isPermanentMember': !exists(json, 'is_permanent_member') ? undefined : json['is_permanent_member'],
        'isMainPerformer': !exists(json, 'is_main_performer') ? undefined : json['is_main_performer'],
        'linkedAliasId': !exists(json, 'linked_alias_id') ? undefined : json['linked_alias_id'],
        'createdBySystem': !exists(json, 'created_by_system') ? undefined : json['created_by_system'],
    };
}

export function ArtistBandToJSON(value?: ArtistBand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'created_by_system': value.createdBySystem,
    };
}

